// Transport company codes by transport type
export interface TransportCompany {
  code: string;
  name?: string; // Optional display name, can be added later
  transportType: number; // 1 = Air, 2 = Land, 3 = Sea
}

// Complete list of transport companies sorted by code within each type
export const TRANSPORT_COMPANIES: TransportCompany[] = [
  // Sea Companies (Transport Type 3)
  { code: 'AMCL', transportType: 3 },
  { code: 'APLCNC', transportType: 3 },
  { code: 'APLU', transportType: 3 },
  { code: 'ASL', transportType: 3 },
  { code: 'BANQ', transportType: 3 },
  { code: 'BEN LINE', transportType: 3 },
  { code: 'CK', transportType: 3 },
  { code: 'CMDU', transportType: 3 },
  { code: 'COSCO', transportType: 3 },
  { code: 'CSCL', transportType: 3 },
  { code: 'CSAV', transportType: 3 },
  { code: 'CTS', transportType: 3 },
  { code: 'CULK', transportType: 3 },
  { code: 'DAHK', transportType: 3 },
  { code: 'DMAL', transportType: 3 },
  { code: 'EGLV', transportType: 3 },
  { code: 'ESL', transportType: 3 },
  { code: 'FCSL', transportType: 3 },
  { code: 'GSL', transportType: 3 },
  { code: 'HAL', transportType: 3 },
  { code: 'HARBOUR-LINK', transportType: 3 },
  { code: 'HDASL', transportType: 3 },
  { code: 'HLCU', transportType: 3 },
  { code: 'HMDU', transportType: 3 },
  { code: 'HUARONG', transportType: 3 },
  { code: 'IAL', transportType: 3 },
  { code: 'JINJIANG', transportType: 3 },
  { code: 'KLINE', transportType: 3 },
  { code: 'KMTC', transportType: 3 },
  { code: 'KNAY', transportType: 3 },
  { code: 'LLT', transportType: 3 },
  { code: 'MAEU', transportType: 3 },
  { code: 'MCC', transportType: 3 },
  { code: 'MOLU', transportType: 3 },
  { code: 'MSL', transportType: 3 },
  { code: 'MSCU', transportType: 3 },
  { code: 'MWS', transportType: 3 },
  { code: 'NBOSCO', transportType: 3 },
  { code: 'NSS', transportType: 3 },
  { code: 'NZL', transportType: 3 },
  { code: 'ONE', transportType: 3 },
  { code: 'OOLU', transportType: 3 },
  { code: 'NYK', transportType: 3 },
  { code: 'PANA', transportType: 3 },
  { code: 'PANO', transportType: 3 },
  { code: 'PIL', transportType: 3 },
  { code: 'RCL', transportType: 3 },
  { code: 'RICO', transportType: 3 },
  { code: 'SAMUDERA', transportType: 3 },
  { code: 'SEALAND', transportType: 3 },
  { code: 'SHKK', transportType: 3 },
  { code: 'SINOKOR', transportType: 3 },
  { code: 'SinoTrans', transportType: 3 },
  { code: 'SITC', transportType: 3 },
  { code: 'SML', transportType: 3 },
  { code: 'SPS', transportType: 3 },
  { code: 'TSL', transportType: 3 },
  { code: 'WHLU', transportType: 3 },
  { code: 'WOSCO', transportType: 3 },
  { code: 'XJG', transportType: 3 },
  { code: 'YMLU', transportType: 3 },
  { code: 'YUHE', transportType: 3 },
  { code: 'ZIM', transportType: 3 },
  
  // Air Companies (Transport Type 1)
  { code: '3G', transportType: 1 },
  { code: '3U', transportType: 1 },
  { code: '3V', transportType: 1 },
  { code: '5X', transportType: 1 },
  { code: '5Y', transportType: 1 },
  { code: '6U', transportType: 1 },
  { code: 'A3', transportType: 1 },
  { code: 'AA', transportType: 1 },
  { code: 'AC', transportType: 1 },
  { code: 'AE', transportType: 1 },
  { code: 'AF', transportType: 1 },
  { code: 'AI', transportType: 1 },
  { code: 'AS', transportType: 1 },
  { code: 'AV', transportType: 1 },
  { code: 'AY', transportType: 1 },
  { code: 'BA', transportType: 1 },
  { code: 'BI', transportType: 1 },
  { code: 'BR', transportType: 1 },
  { code: 'CA', transportType: 1 },
  { code: 'CF', transportType: 1 },
  { code: 'CI', transportType: 1 },
  { code: 'CK', transportType: 1 },
  { code: 'CV', transportType: 1 },
  { code: 'CX', transportType: 1 },
  { code: 'CY', transportType: 1 },
  { code: 'CZ', transportType: 1 },
  { code: 'DB', transportType: 1 },
  { code: 'DL', transportType: 1 },
  { code: 'EK', transportType: 1 },
  { code: 'ET', transportType: 1 },
  { code: 'EZ', transportType: 1 },
  { code: 'FD', transportType: 1 },
  { code: 'FI', transportType: 1 },
  { code: 'FM', transportType: 1 },
  { code: 'FX', transportType: 1 },
  { code: 'GA', transportType: 1 },
  { code: 'GG', transportType: 1 },
  { code: 'GM', transportType: 1 },
  { code: 'HO', transportType: 1 },
  { code: 'HT', transportType: 1 },
  { code: 'HU', transportType: 1 },
  { code: 'HX', transportType: 1 },
  { code: 'HY', transportType: 1 },
  { code: 'IR', transportType: 1 },
  { code: 'JD', transportType: 1 },
  { code: 'JL', transportType: 1 },
  { code: 'JM', transportType: 1 },
  { code: 'JS', transportType: 1 },
  { code: 'JX', transportType: 1 },
  { code: 'KA', transportType: 1 },
  { code: 'KE', transportType: 1 },
  { code: 'KL', transportType: 1 },
  { code: 'KU', transportType: 1 },
  { code: 'KW', transportType: 1 },
  { code: 'KZ', transportType: 1 },
  { code: 'LD', transportType: 1 },
  { code: 'LH', transportType: 1 },
  { code: 'LO', transportType: 1 },
  { code: 'LY', transportType: 1 },
  { code: 'M7', transportType: 1 },
  { code: 'MA', transportType: 1 },
  { code: 'MF', transportType: 1 },
  { code: 'MH', transportType: 1 },
  { code: 'MI', transportType: 1 },
  { code: 'MU', transportType: 1 },
  { code: 'N7', transportType: 1 },
  { code: 'N8', transportType: 1 },
  { code: 'NG', transportType: 1 },
  { code: 'NH', transportType: 1 },
  { code: 'NW', transportType: 1 },
  { code: 'NX', transportType: 1 },
  { code: 'NZ', transportType: 1 },
  { code: 'O3', transportType: 1 },
  { code: 'OA', transportType: 1 },
  { code: 'OK', transportType: 1 },
  { code: 'OM', transportType: 1 },
  { code: 'OS', transportType: 1 },
  { code: 'OZ', transportType: 1 },
  { code: 'PK', transportType: 1 },
  { code: 'PO', transportType: 1 },
  { code: 'PR', transportType: 1 },
  { code: 'QF', transportType: 1 },
  { code: 'QR', transportType: 1 },
  { code: 'QT', transportType: 1 },
  { code: 'RA', transportType: 1 },
  { code: 'RG', transportType: 1 },
  { code: 'RH', transportType: 1 },
  { code: 'RJ', transportType: 1 },
  { code: 'RO', transportType: 1 },
  { code: 'SA', transportType: 1 },
  { code: 'SK', transportType: 1 },
  { code: 'SQ', transportType: 1 },
  { code: 'SR', transportType: 1 },
  { code: 'SU', transportType: 1 },
  { code: 'SV', transportType: 1 },
  { code: 'TG', transportType: 1 },
  { code: 'TH', transportType: 1 },
  { code: 'TK', transportType: 1 },
  { code: 'TR', transportType: 1 },
  { code: 'UA', transportType: 1 },
  { code: 'UB', transportType: 1 },
  { code: 'UL', transportType: 1 },
  { code: 'VN', transportType: 1 },
  { code: 'VS', transportType: 1 },
  { code: 'WW', transportType: 1 },
  { code: 'Y8', transportType: 1 },
  { code: 'YG', transportType: 1 },
  { code: 'ZH', transportType: 1 },
  
  // Land Company (Transport Type 2)
  { code: 'LAND', transportType: 2 }
];

// Helper function to get companies by transport type
export function getCompaniesByTransportType(transportType: number): TransportCompany[] {
  return TRANSPORT_COMPANIES.filter(company => company.transportType === transportType);
}
